import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';

const LoginModal = ({ onClose, onSwitchToSignUp, onSwitchToForgotPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUser } = useUser();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch('/api/v1/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (response.ok) {
      setUser(data);
      onClose();
    } else {
      setError(data.error || 'Login failed.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Login</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>&times;</button>
        </header>
        <form onSubmit={handleSubmit}>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <label htmlFor="password">Password</label>
          <input type="password" id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button type="submit">Log in</button>
          <p style={{ textAlign: 'center', marginTop: '1rem' }}>
            <small>
              Don't have an account?{' '}
              <a href="#" onClick={(e) => { e.preventDefault(); onSwitchToSignUp(); }}>Sign Up</a>
            </small>
          </p>
          <p style={{ textAlign: 'center', marginTop: '0.5rem' }}>
            <small>
              <a href="#" onClick={(e) => { e.preventDefault(); onSwitchToForgotPassword(); }}>Forgot Password?</a>
            </small>
          </p>
        </form>
      </article>
    </div>
  );
};

export default LoginModal;